import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Logo from "../components/common/Logo";
import { ROUTES } from "../utils/constants";

const ModeratorDashboard = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
    } finally {
      navigate(ROUTES.ADMIN_LOGIN, { replace: true });
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <div className="container">
          <div className="header-content">
            <div className="header-left">
              <Logo size="medium" className="header-logo" />
              <h1 className="dashboard-title">Mirt Sew — Moderator Panel</h1>
            </div>
            <div className="dashboard-actions">
              <div className="user-info">Welcome, {user?.email}</div>
              <button
                onClick={() => navigate(ROUTES.CHANGE_PASSWORD)}
                className="nav-button"
                type="button"
                style={{ marginRight: "0.5rem" }}
              >
                🔑 Change Password
              </button>
              <button
                onClick={handleLogout}
                className="logout-btn"
                type="button"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="container">
          <div
            style={{
              maxWidth: "600px",
              margin: "3rem auto",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: "var(--text-secondary)",
                marginBottom: "2.5rem",
                fontSize: "1rem",
              }}
            >
              You have moderator access. Select a section to manage:
            </p>

            <div
              style={{
                display: "flex",
                gap: "1.5rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                type="button"
                onClick={() => navigate(ROUTES.ITEM_MANAGEMENT)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.75rem",
                  padding: "2rem 2.5rem",
                  background: "var(--bg-secondary)",
                  border: "2px solid var(--border-primary)",
                  borderRadius: "0.75rem",
                  cursor: "pointer",
                  color: "var(--text-primary)",
                  minWidth: "180px",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--color-primary)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 16px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-primary)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <span style={{ fontSize: "2.5rem" }}>🛒</span>
                <span style={{ fontWeight: "600", fontSize: "1rem" }}>
                  Item Management
                </span>
                <span
                  style={{
                    fontSize: "0.8125rem",
                    color: "var(--text-secondary)",
                  }}
                >
                  Manage products & categories
                </span>
              </button>

              <button
                type="button"
                onClick={() => navigate(ROUTES.LOCATION_MANAGEMENT)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.75rem",
                  padding: "2rem 2.5rem",
                  background: "var(--bg-secondary)",
                  border: "2px solid var(--border-primary)",
                  borderRadius: "0.75rem",
                  cursor: "pointer",
                  color: "var(--text-primary)",
                  minWidth: "180px",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--color-success)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 16px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-primary)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <span style={{ fontSize: "2.5rem" }}>📍</span>
                <span style={{ fontWeight: "600", fontSize: "1rem" }}>
                  Location Management
                </span>
                <span
                  style={{
                    fontSize: "0.8125rem",
                    color: "var(--text-secondary)",
                  }}
                >
                  Manage regions, zones & cities
                </span>
              </button>

              <button
                type="button"
                onClick={() => navigate(ROUTES.ORDERS)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.75rem",
                  padding: "2rem 2.5rem",
                  background: "var(--bg-secondary)",
                  border: "2px solid var(--border-primary)",
                  borderRadius: "0.75rem",
                  cursor: "pointer",
                  color: "var(--text-primary)",
                  minWidth: "180px",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--color-warning)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 16px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--border-primary)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <span style={{ fontSize: "2.5rem" }}>📦</span>
                <span style={{ fontWeight: "600", fontSize: "1rem" }}>
                  Orders
                </span>
                <span
                  style={{
                    fontSize: "0.8125rem",
                    color: "var(--text-secondary)",
                  }}
                >
                  Manage customer orders
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeratorDashboard;
